<script lang="ts">
  import { BITSKI_API_V1 } from '$lib/constants';

  export let id: string;

  let showing = false;

  function handleGlobalShortcut(e: KeyboardEvent) {
    if (e.code === 'KeyC' && e.ctrlKey && e.altKey) {
      showing = !showing;
    }
  }

  async function handleSubmit() {
    try {
      await fetch(`${BITSKI_API_V1}/products/${id}/curation`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ isPromoted: true }),
      });
    } finally {
      showing = false;
    }
  }
</script>

<svelte:window on:keyup={handleGlobalShortcut} />

{#if showing}
  <div class="fixed inset-0 flex justify-center items-center z-50 backdrop-filter backdrop-blur-lg">
    <form class="card" on:submit|preventDefault={handleSubmit}>
      <h3 class="heading-2 border-b border-grey-aux pb-2 mb-4">Curate content</h3>
      <p>Promote this content?</p>
      <div class="text-right">
        <button type="button" class="btn btn-secondary" on:click={() => (showing = false)}>
          Cancel
        </button>

        <button type="submit" class="btn btn-primary">Submit</button>
      </div>
    </form>
  </div>
{/if}
